<template>
    <div>

        <!-- Delete draft card -->

        <trax-ui-card :title="lang.polaris.procedure.delete_procedure" title-bold="1" v-show="visible && launchPermission && atpDafEditStatus">

            {{ lang.polaris.procedure.delete_procedure_text }}

            <div class="mt-3 text-right">
                <button class="btn btn-round btn-default" @click="deleteProcedure">
                    {{ lang.polaris.form.delete }}
                </button>    
            </div>

        </trax-ui-card>

        <!-- Delete draft confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete-modal'" :title="lang.polaris.procedure.procedure_deletion" :bus="bus">
            {{ lang.polaris.procedure.confirm_procedure_deletion_q }}
        </trax-ui-modal-confirm>
    
        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-delete-toastr'" passed-label="1" :bus="bus">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            hiddenWhen: null,
            atp: null,
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                user: user,
                endpoint: app_url+'polaris/api/front/procedures/'+data.procedure.id,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                visible: !this.hiddenWhen,
                bus: this.$bus
            }
        },

        computed: {

            launchPermission: function() {
                if (this.user.admin) return true;
                if (this.atp && this.user.permissions['procedure.write-atp']) return true;
                if (!this.atp && this.user.permissions['procedure.write-daf']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            },

            redirect: function() {
                var res = this.app_url+'polaris/ui/atpl-dashboard/registration/'+this.registration.id+'/enac-atpl-phase/'+this.phase.id;
                if (this.learner) res += '/learner/'+this.learner.id;
                return res;
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-delete-modal-confirmed', this.deleteProcedureConfirmed);
        },

        methods:  {

            setData(procedure) {
                this.visible = !this.hiddenWhen || !procedure.data[this.hiddenWhen];
            },

            deleteProcedure() {
                this.bus.$emit(this.id+'-delete-modal-open');
            },

            deleteProcedureConfirmed() {
                this.deleteData();
            },

            deleteData(data) {
                var that = this;
                axios.delete(this.endpoint)
                    .then(function (response) {
                        window.location = that.redirect;
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.id+'-delete-toastr-error', error.response.data);
                    });
            }
        }

    }
</script>
